export default {
  'contact-me': 'Me tenir informé(e)',
  'not-delivered-waiting-list1': 'Nous ne livrons pas encore cette adresse',
  'not-delivered-waiting-list2':
    " mais nous pouvons vous envoyer un e-mail dès qu'elle sera dans notre zone de livraison.",
  'waiting-list-success': 'Merci, nous avons bien noté votre adresse\xA0!',
  'email-placeholder': 'Indiquez votre adresse e-mail',
  'button-label': 'Découvrez nos points de retrait',
};
